import { render, staticRenderFns } from "./typeOne.vue?vue&type=template&id=6d2cf3ea&scoped=true"
import script from "./typeOne.vue?vue&type=script&lang=js"
export * from "./typeOne.vue?vue&type=script&lang=js"
import style0 from "./typeOne.vue?vue&type=style&index=0&id=6d2cf3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2cf3ea",
  null
  
)

export default component.exports